export const searchAttributes = [
  {
    field: 'field_municipality',
    weight: 22,
  },
];

export const resultAttributes = [
  'url',
  'title',
  'field_municipality',
  'body',
  'body_secondary',
  'field_request_type',
  'field_organization',
  'field_project_type',
  'field_weekly_time_spent',
];

export const sorting = {
  default: {
    field: '_score',
    order: 'desc',
  },
};

export const facetAttributes = [
  {
    attribute: 'field_request_type',
    field: 'field_request_type',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
  {
    attribute: 'field_target_audience_age',
    field: 'field_target_audience_age',
    type: 'string',
  },
  {
    attribute: 'field_activity_types',
    field: 'field_activity_types',
    type: 'string',
  },
  {
    attribute: 'field_weekly_time_spent',
    field: 'field_weekly_time_spent',
    type: 'string',
  },
  {
    attribute: 'field_project_theme',
    field: 'field_project_theme',
    type: 'string',
  },
];
